import * as actions from './actions';
import { ADMIN_VIEW, VIEW } from './constants';

const userState = {
  user: null,
  isLoading: true,
  view: localStorage.getItem(VIEW) || ADMIN_VIEW,
};

function accountReducer(state = userState, action: any) {
  switch (action.type) {
    case actions.SIGN_USER_IN:
      return {
        ...state,
        user: action.payload,
        isLoading: false,
      };
    case actions.SIGN_USER_OUT:
      return {
        ...state,
        user: null,
      };
    case actions.SET_USER_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case actions.SET_VIEW:
      localStorage.setItem(VIEW, action.payload);
      return {
        ...state,
        view: action.payload,
      };
    default:
      return state;
  }
}

export default accountReducer;
